<script>
    import { onMount } from "svelte";
    import ProgressBar from "./components/ProgressBar.svelte";
    import { fly } from "svelte/transition";
    import BtnPict from "./components/BtnPict.svelte";

    const driver = new Driver({
        allowClose: false,
        nextBtnText: "次へ =>",
        prevBtnText: "<= 前へ",
        doneBtnText: "ゲームスタート",
        position: "bottom",
    });

    let appearImg = 6;
    let imgArray = [];

    let isVisible = false;
    export let tutorialEndFunc = () => {
        console.log("チュートリアル終了時の関数");
    };

    export const changeImage = () => {
        setAnimation();
        imgArray = [];
        const appearRnd = 0;
        for (let step = 0; step < appearImg; step++) {
            if (appearRnd == step) {
                imgArray = [...imgArray, `pict_img/1-A.png`];
            } else {
                imgArray = [...imgArray, `pict_img/1-B.png`];
            }
        }
    };

    setTimeout(() => {
        driver.defineSteps([
            {
                element: "#game-area",
                popover: {
                    title: "ゲームエリア",
                    description: "この中から違う画像を探してタップしてください",
                },
            },
            {
                element: "#clickable_pict_btn",
                popover: {
                    title: "仲間外れの画像",
                    description:
                        "タップすると点数が入り違う画像に切り替わります。",
                    position: "bottom",
                }
            },
            {
                element: "#progressbar",
                popover: {
                    title: "時間制限バー",
                    description: "時間制限のバーがなくなるとゲーム終了です。",
                    position: "top-center",
                    // allowClose: true,
                },
                nextBtnText: "ゲームスタート",
                onNext: () => {
                    driver.getHighlightedElement().hidePopover();
                    
                    setTimeout(() => {
                        driver.reset()
                        tutorialEndFunc();
                    }, 500);
                    
                },
            },
            {
                element: "#progressbar",
            },
        ]);

        driver.start();


        // let driverClose = document.getElementsByClassName("driver-close-btn");
        // let driverClose = document.querySelector("#driver-popover-item > div.driver-clearfix.driver-popover-footer > button")
        // driverClose[0].style.display ="none";
        // element = document.querySelector(selectors);
        // console.log(driverClose);
        // driverClose.forEach((ele) => ele.setAttribute("type", "hidden"));
    }, 1000);

    const setAnimation = () => {
        isVisible = false;
        setTimeout(() => (isVisible = true), 500);
    };

    onMount(() => {
        changeImage();
    });
</script>

{#if isVisible}
    <div
        id="game-area"
        transition:fly={{ y: 100 }}
        class="container has-text-centered">
        {#each imgArray as img}
            <BtnPict imagePath={img} />
        {/each}
    </div>

    <ProgressBar />
{/if}
